export default __webpack_public_path__ + "static/veloxballsleep-5d5870fb7514f6adf4b62f7b2f3a8e8d.png";